import './assets/main.scss'
import 'vfonts/Lato.css'
import 'vfonts/FiraCode.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { initSentry } from './config/sentry'
import dates from './plugins/dates'
import ToolbarComponent from './components/ToolbarComponent.vue'
import NavLinkComponent from './components/NavLinkComponent.vue'

import App from './App.vue'
import router from './router'

const app = createApp(App)

initSentry(app, router)

app.component('toolbar', ToolbarComponent)
app.component('nav-link', NavLinkComponent)

app.directive('focus', {
  mounted(el) {
    const input = el.querySelector('.n-input__input-el')
    input?.focus()
  }
})

app.use(createPinia())
app.use(router)
app.use(dates, { locale: 'da-DK' })

router.isReady().then(() => {
  app.mount('#app')
})
